var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-mat",
    d: "M4.85,4h0a.85.85,0,0,1,.85.85v15.3a.85.85,0,0,1-.85.85h0A.85.85,0,0,1,4,20.15V4.85A.85.85,0,0,1,4.85,4ZM7.4,16.75v1.7h6.8a.85.85,0,0,0,.85-.85h0a.85.85,0,0,0-.85-.85Zm0-10.2v1.7H20.15A.85.85,0,0,0,21,7.4h0a.85.85,0,0,0-.85-.85Zm0,6.8v1.7h9.35a.85.85,0,0,0,.85-.85h0a.85.85,0,0,0-.85-.85Zm0-3.4v1.7h5.525a.85.85,0,0,0,.85-.85h0a.85.85,0,0,0-.85-.85Z",
    transform: "translate(-4 -4)",
    fill: "#45338c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMat);
export default __webpack_public_path__ + "static/media/icon-mat.b70451a125abe3551f277f224db4cc22.svg";
export { ForwardRef as ReactComponent };